import { createSelector } from 'reselect'
import { RootState } from '../store'
import { IWellWaterSystem } from '../../types'

export const selectWellWaterSystemsLoading = (state: RootState) => state.wellWaterSystems.loading
export const selectWellWaterSystemsError = (state: RootState) => state.wellWaterSystems.error
export const selectWellWaterSystemsSuccess = (state: RootState) => state.wellWaterSystems.success
export const userSearchedForWells = (state: RootState) => state.wellWaterSystems.userSearched

export const selectSelectedWellWaterSystem = (state: RootState) =>
  state.wellWaterSystems.selectedWellWaterSystem

const selectWellWaterSystems = (state:RootState)=> state.wellWaterSystems.data?.wellWaterSystems || [] as IWellWaterSystem[]

const makeWellWaterSystems = createSelector(
  [selectWellWaterSystems],
  (data) => {
    return data.map((system: IWellWaterSystem) => ({
      ...system,
    }));
  }
)

export const selectWellWaterSystemsIdsAndAddresses = createSelector(
  [selectWellWaterSystems],
  (data) =>
    data.map((system: IWellWaterSystem) => ({
      id: system._id,
      address: `Block Group: ${system.GEOID_BlkGrp}`,
    }))
)

export const WellWaterSystemsSelector = {
  makeWellWaterSystems,
  selectWellWaterSystemsLoading,
  selectWellWaterSystemsError,
  selectWellWaterSystemsSuccess,
  selectSelectedWellWaterSystem,
  selectWellWaterSystemsIdsAndAddresses,
  userSearchedForWells,
}
